import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, User, Users, Printer, ArrowUpRight } from 'lucide-react';
export function ApparelsPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-205" data-mp="26f4i2zn523ex">
      <Header data-id="element-206" data-mp="2bdphwxyhal2u" />

      <main className="pt-32 pb-24 min-h-screen" data-id="element-207" data-mp="2bdfu9h0woq0b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208" data-mp="1wq4fz7dcarwi">
          <a href="/" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-209" data-mp="1wojojqmbnp2v">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-210" data-mp="1nqzi839lr2le" />
            Back to Home
          </a>

          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-211" data-mp="1rsbbciroq5yc">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-212" data-mp="1dricjlucoopf">
              TwiceBourne Apparels
            </h1>
            <p className="text-2xl text-slate-300 mb-4" data-id="element-213" data-mp="1iqv0yb0ve3u4">
              Custom-made fashion for twins, tailored by hand
            </p>
            <p className="text-lg text-slate-400" data-id="element-214" data-mp="mj8ljwem5k92">
              High-end fabric and garments, focusing on making matching apparels
              for twins. Where comfort meets sophisticated design.
            </p>
          </div>

          {/* Featured — live store */}
          <a href="https://apparels.twicebourne.com" target="_blank" rel="noopener noreferrer" className="group block max-w-5xl mx-auto mb-10 rounded-3xl overflow-hidden border border-fuchsia-400/40 hover:border-fuchsia-300 bg-[#1A1030] shadow-2xl transition-colors duration-200" data-id="element-215" data-mp="qnq5bvkz3xju">
            <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-216" data-mp="coytkftl2nyv">
              <div className="relative h-64 md:h-auto overflow-hidden" data-id="element-217" data-mp="7vdrabkyj7tv">
                <img src="https://cdn.magicpatterns.com/patterns/generated-images/1bf638fb-6da0-4224-8106-03721fa589b5.jpg" alt="Vibrant all-over sublimation printed shirt and hoodie" className="w-full h-full object-cover transform transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-218" data-mp="3gbgy6f48wsh5" />
              </div>

              <div className="p-10 flex flex-col justify-center" data-id="element-219" data-mp="1ozsttpmex6wj">
                <div className="flex items-center gap-3 mb-5" data-id="element-220" data-mp="1p1nh3al5pb3s">
                  <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-400/15 border border-emerald-400/40 text-emerald-300 text-xs font-bold uppercase tracking-wider" data-id="element-221" data-mp="1txcaew6l1vrn">
                    <span className="w-2 h-2 rounded-full bg-emerald-400" data-id="element-222" data-mp="11arjtxxxlnp5" />
                    Now Open
                  </span>
                  <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-fuchsia-500/20 text-fuchsia-300" data-id="element-223" data-mp="16b5ttlj3f7pt">
                    <Printer className="w-5 h-5" aria-hidden="true" data-id="element-224" data-mp="2hoi0032bs2f5" />
                  </span>
                </div>

                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-225" data-mp="2lp1yb9ymxc2v">
                  Custom Clothing Store
                </h2>
                <p className="text-fuchsia-300 text-lg font-semibold mb-4" data-id="element-226" data-mp="a1onc3xnny27">
                  Full Sublimation Prints
                </p>
                <p className="text-slate-300 text-lg leading-relaxed mb-7" data-id="element-227" data-mp="19wgs4br592w">
                  Bring your designs to life with edge-to-edge, all-over
                  sublimation printing. Unlimited color, zero cracking, made to
                  order — shop the collection or upload your own artwork.
                </p>

                <span className="inline-flex items-center gap-2 self-start px-6 py-3 rounded-full bg-fuchsia-500 text-white font-semibold transition-colors duration-200 group-hover:bg-fuchsia-400" data-id="element-228" data-mp="3ii073zd2go0o">
                  Shop apparels.twicebourne.com
                  <ArrowUpRight className="w-5 h-5" aria-hidden="true" data-id="element-229" data-mp="39joc7l56342f" />
                </span>
              </div>
            </div>
          </a>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-230" data-mp="17pyraoh04vvy">
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 p-10 flex flex-col items-center text-center" data-id="element-231" data-mp="4fkntd74k20i">
              <div className="w-20 h-20 rounded-full bg-white/10 flex items-center justify-center mb-8 text-slate-400" data-id="element-232" data-mp="9d4e5bh3k58t">
                <User className="w-10 h-10" data-id="element-233" data-mp="3rjqxyid2mk8w" />
              </div>
              <h2 className="text-2xl font-bold text-slate-200 mb-4" data-id="element-234" data-mp="cobg486h250">
                TwiceBourne Clothing
              </h2>
              <div className="flex flex-wrap items-center justify-center gap-2 mb-6" data-id="element-235" data-mp="3hswdnjjdxuq3">
                <span className="inline-block px-4 py-1 rounded-full bg-slate-800 text-slate-300 text-sm font-medium" data-id="element-236" data-mp="3mmihcm7kmo9r">
                  Men's Line
                </span>
                <span className="inline-block px-4 py-1 rounded-full bg-amber-400/10 border border-amber-400/30 text-amber-300 text-sm font-medium" data-id="element-237" data-mp="3cucrpj4skixq">
                  Launching 2028
                </span>
              </div>
              <p className="text-slate-400 text-lg mt-auto" data-id="element-238" data-mp="33t4vr7pqzu6t">
                Premium, sustainably sourced clothing designed specifically for
                the modern man.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 p-10 flex flex-col items-center text-center" data-id="element-239" data-mp="2fb4gck8cq3r3">
              <div className="w-20 h-20 rounded-full bg-white/10 flex items-center justify-center mb-8 text-slate-400" data-id="element-240" data-mp="2p7r015oxyorj">
                <Users className="w-10 h-10" data-id="element-241" data-mp="3370hs9sspqxm" />
              </div>
              <h2 className="text-2xl font-bold text-slate-200 mb-4" data-id="element-242" data-mp="3355tclibfgos">
                Fabrictwinz
              </h2>
              <div className="flex flex-wrap items-center justify-center gap-2 mb-6" data-id="element-243" data-mp="3cx22crlxwr7s">
                <span className="inline-block px-4 py-1 rounded-full bg-slate-800 text-slate-300 text-sm font-medium" data-id="element-244" data-mp="37y8o2wytww6k">
                  Women's Line
                </span>
                <span className="inline-block px-4 py-1 rounded-full bg-amber-400/10 border border-amber-400/30 text-amber-300 text-sm font-medium" data-id="element-245" data-mp="3ly9okbb6m1li">
                  Launching 2028
                </span>
              </div>
              <p className="text-slate-400 text-lg mt-auto" data-id="element-246" data-mp="3typg0pj2m880">
                Elegant, hand-tailored fashion focusing on beautiful matching
                sets for twins.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-247" data-mp="7k6bdkjwe7eq" />
    </div>;
}